import React, { Component } from 'react';

import Plotly from "react-plotly.js/react-plotly";
import clone from "clone";

import darkVars from "styles/_vars-dark.scss";
import lightVars from "styles/_vars-light.scss";
import {Context} from "../../../../../context";

//todo: we might be able to optimise this in the future by implementing our own wrapper component for plotly and using plotly.restyle to update only the plot we need

export default class ThreeD extends Component {
    static contextType = Context;

    state = {
        layout: {
            scene: {
                camera: {
                    center: {
                        x: 0,
                        y: 0,
                        z: -0.14
                    }
                },
                xaxis: {
                    autorange: "reversed",
                    tickmode: "array",
                    tickvals: [],
                    title: { text: "" },
                    color: this.context.lightTheme ? lightVars.txtPrimary : darkVars.txtPrimary,
                    gridcolor: this.context.lightTheme ? lightVars.txtSecondary : darkVars.txtSecondary,
                    tickfont: {
                        size: 10
                    }
                },
                yaxis: {
                    tickmode: "array",
                    tickvals: [],
                    title: { text: "" },
                    color: this.context.lightTheme ? lightVars.txtPrimary : darkVars.txtPrimary,
                    gridcolor: this.context.lightTheme ? lightVars.txtSecondary : darkVars.txtSecondary,
                    tickfont: {
                        size: 10
                    }
                },
                zaxis: {
                    rangemode: null,
                    title: { text: "" },
                    color: this.context.lightTheme ? lightVars.txtPrimary : darkVars.txtPrimary,
                    gridcolor: this.context.lightTheme ? lightVars.txtSecondary : darkVars.txtSecondary,
                    tickfont: {
                        size: 10
                    }
                }
            },
            datarevision: 0
        },
        data: [
            {
                name: "",
                x: [],
                y: [],
                z: [],
                type: 'scatter3d',
                mode: "markers",
                marker: {
                    symbol: "circle",
                    size: 5,
                    color: this.context.lightTheme ? "#484848" : "white"
                },
                hovertemplate: "",
            },
            {
                name: "",
                x: [],
                y: [],
                z: [],
                opacity: 1,
                colorscale: [
                    ['0.0', this.context.lightTheme ? lightVars.colourScale5 : darkVars.colourScale5],
                    ['0.25', this.context.lightTheme ? lightVars.colourScale4 : darkVars.colourScale4],
                    ['0.50', this.context.lightTheme ? lightVars.colourScale3 : darkVars.colourScale3],
                    ['0.75', this.context.lightTheme ? lightVars.colourScale2 : darkVars.colourScale2],
                    ['1.0', this.context.lightTheme ? lightVars.colourScale1 : darkVars.colourScale1]
                ],
                type: 'surface',
                colorbar: {
                    len: 0,
                    thickness: 0,
                    xpad: 0,
                    ypad: 0,
                    outlinewidth: 0,
                    bgcolor: "rgba(0,0,0,0)",
                    ticklen: 0,
                    showticklabels: false
                },
                contours: {
                    x: { show: true, color: this.context.lightTheme ? "#484848" : "black" },
                    y: { show: true, color: this.context.lightTheme ? "#484848" : "black" },
                    z: {} // hack so that contour lines update on render
                },
                hoverlabel: {
                    bgcolor: "ffffff",
                },
                hovertemplate: "",
            }
        ],
        frames: [],
        config: {}
    };

    static getDerivedStateFromProps(props, state){
        // if (!state.isMounted) return null;

        const table = props.table;

        // format matrix values in each axis - format plotly Surface3D accepts this
        const surfaceX = table.xAxis.matrix.values.reduce((acc, val) => acc.concat(val), []);
        const surfaceY = table.yAxis.matrix.values.reduce((acc, val) => acc.concat(val), []);
        const surfaceZ = table.dataAxis.matrix.values;

        let scatterX = null;
        let scatterY = null;
        let scatterZ = null;

        let {topLeft, bottomRight} = props.selection;

        // map to format plotly Scatter3D accepts
        if(topLeft.i !== undefined){
            scatterX = surfaceX.map(() => clone(surfaceX)).reduce((acc, val) => acc.concat(val), []);
            scatterY = surfaceY.map(val => new Array(surfaceX.length).fill(val)).reduce((acc, val) => acc.concat(val), []);
            // limit scatter to selected points
            scatterZ = surfaceZ.map((row, i) =>
                row.map((cell, j) => (i >= topLeft.i && i <= bottomRight.i && j >= topLeft.j && j <= bottomRight.j) ? cell : null)
            ).reduce((acc, val) => acc.concat(val), []);
        }

        const values = surfaceZ.reduce((acc, val) => acc.concat(val), []);
        const valuesSame = values.every(value => value === values[0]);
        const planeHeight = valuesSame ? values[0] : null;

        const osc = props.revision % 2 === 0;

        const hovertemplate =
            `x: ${table.xAxis.name.substring(0, 15)}${table.xAxis.name.length > 15 ? "..." : ""}: %{x} ${table.xAxis.units}<br>`+
            `y: ${table.yAxis.name.substring(0, 15)}${table.xAxis.name.length > 15 ? "..." : ""}: %{y} ${table.yAxis.units}<br>`+
            `z: ${table.dataAxis.name.substring(0, 15)}${table.xAxis.name.length > 15 ? "..." : ""}: %{z} ${table.dataAxis.units}`;

        const figure = state;

        figure.layout.datarevision = figure.layout.datarevision + 1;

        figure.layout.scene.xaxis.tickvals = surfaceX;
        figure.layout.scene.xaxis.title.text = table.xAxis.units;

        figure.layout.scene.yaxis.tickvals = surfaceY;
        figure.layout.scene.yaxis.title.text = table.yAxis.units;

        figure.layout.scene.zaxis.rangemode = planeHeight !== null ? "tozero" : null;
        figure.layout.scene.zaxis.title.text = table.dataAxis.units;

        figure.data[0].x = scatterX;
        figure.data[0].y = scatterY;
        figure.data[0].z = scatterZ;
        figure.data[0].hovertemplate = hovertemplate;

        figure.data[1].x = surfaceX;
        figure.data[1].y = surfaceY;
        figure.data[1].z = surfaceZ;
        figure.data[1].hovertemplate = hovertemplate;
        figure.data[1].contours.z = { show: osc, start: 0, end: 1, size: 100000000000}; // hack so that contour lines update on render

        return figure;
    }

    render() {
        return (
            <div>
                <Plotly
                    revision={this.state.layout.datarevision}
                    data={this.state.data}
                    layout={this.state.layout}
                    frames={this.state.frames}
                    config={this.state.config}
                    useResizeHandler={true}
                    min="0"
                    max={200}
                    style={{
                        minWidth: "100%",
                        minHeight: "100%",
                        width: "100%",
                        height: "100%",
                    }}
                />
            </div>
        )
    }
}